// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__25yAO","requiredAsterisk":"Info_requiredAsterisk__2pQrn"};